module.exports = __webpack_public_path__ + "img/5.cb5b3008.jpg";